export default __webpack_public_path__ + "static/media/theniaSL.dd08fab3.jpg";